export default __webpack_public_path__ + "static/media/ic-videos.702bf763.svg";